import L, { LatLngTuple } from 'leaflet';
import { TileLayer } from 'react-leaflet';

// import MouseCoordinates from './MouseCoordinates';

export const overlayTile = [
    {
        label: '2GIS',
        tile: (
            <TileLayer url='https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}' />
        ),
        checked: true,
    },
    {
        label: 'Google',
        tile: (
            <TileLayer
                subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                url='https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'
            />
        ),
    },
];

export const centerPosition: L.LatLngExpression = [
    47.79377287942938, 67.70590786380265,
];

// export const mapBounds: L.LatLngBoundsExpression = [
//     [55.06002, 69.670413], // Верхняя правая точка границы
//     [54.677242, 68.708321], // Нижняя левая точка границы
// ];

export const MapMarker = (color: string) => {
    const svgString = `
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='${color}'
        id='Layer_1'
        data-name='Layer 1'
        viewBox='0 0 24 24'
        width='512'
        height='512'
    >
        <path d='M12,0A10.011,10.011,0,0,0,2,10c0,5.282,8.4,12.533,9.354,13.343l.646.546.646-.546C13.6,22.533,22,15.282,22,10A10.011,10.011,0,0,0,12,0Zm0,15a5,5,0,1,1,5-5A5.006,5.006,0,0,1,12,15Z' />
        <circle fill='${color}' cx='12' cy='10' r='3' />
    </svg>
`;

    return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
};

// export const DefaultMapTools = () => {
//     return (
//         <>
//             <FullscreenControl title={'2'} />
//             {/* <MouseCoordinates /> */}
//         </>
//     );
// };

export const ASTANA_CENTER: LatLngTuple = [51.129546, 71.443115];
